var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "chart",
      staticClass: "gantt-elastic__chart",
      style: { ..._vm.root.style["chart"] },
    },
    [
      _c(
        "div",
        {
          ref: "chartCalendarContainer",
          staticClass: "gantt-elastic__chart-calendar-container",
          style: {
            ..._vm.root.style["chart-calendar-container"],
            height: _vm.root.state.options.calendar.height + "px",
            "margin-bottom": _vm.root.state.options.calendar.gap + "px",
          },
        },
        [_c("calendar")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "chartGraphContainer",
          staticClass: "gantt-elastic__chart-graph-container",
          style: {
            ..._vm.root.style["chart-graph-container"],
            height:
              _vm.root.state.options.height -
              _vm.root.state.options.calendar.height +
              "px",
          },
        },
        [
          _c(
            "div",
            {
              style: {
                ..._vm.root.style["chart-area"],
                width: _vm.root.state.options.width + "px",
                height: _vm.root.state.options.rowsHeight + "px",
              },
            },
            [
              _c(
                "div",
                {
                  ref: "chartGraph",
                  staticClass: "gantt-elastic__chart-graph",
                  style: { ..._vm.root.style["chart-graph"], height: "100%" },
                },
                [
                  _c(
                    "svg",
                    {
                      ref: "chartGraphSvg",
                      staticClass: "gantt-elastic__chart-graph-svg",
                      style: { ..._vm.root.style["chart-graph-svg"] },
                      attrs: {
                        x: "0",
                        y: "0",
                        width: _vm.root.state.options.width + "px",
                        height:
                          _vm.root.state.options.allVisibleTasksHeight + "px",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("days-highlight"),
                      _vm._v(" "),
                      _c("grid"),
                      _vm._v(" "),
                      _c("dependency-lines", {
                        attrs: { tasks: _vm.root.visibleTasks },
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.root.visibleTasks, function (task) {
                        return _c(
                          "g",
                          {
                            key: task.id,
                            staticClass: "gantt-elastic__chart-row-wrapper",
                            style: { ..._vm.root.style["chart-row-wrapper"] },
                            attrs: { task: task, "data-taskid": task.id },
                          },
                          [
                            _c(task.type, {
                              tag: "component",
                              attrs: { task: task },
                            }),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "line",
                        _vm._b(
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.connectingLine.show,
                                expression: "connectingLine.show",
                              },
                            ],
                            staticStyle: {
                              stroke: "rgba(0, 119, 192, 0.5)",
                              "stroke-width": "4",
                            },
                          },
                          "line",
                          _vm.getContLine,
                          false
                        )
                      ),
                    ],
                    2
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }